<template>
  <qx-card-form title="新增出入库记录">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="outboundObjects" slot-scope="prop">
        <el-radio-group v-model="prop.form.outboundObjects" @input="outboundObjectsInput">
          <el-radio-button label="车辆"></el-radio-button>
          <el-radio-button :style="{'border-left':prop.form.outboundObjects==='司机'?'1px soild #0088FF':'1px solid #DCDFE6'}" style="margin-left:20px; border-radius: 4px 4px 4px 4px;" label="司机" ></el-radio-button>
        </el-radio-group>
      </section>
      <section slot="outboundObjectsName" slot-scope="prop">
        <ChooseVehicle
            style="display: inline-block"
            v-if="prop.form.outboundObjects==='车辆'"
            :isRadio="true"
            :disabled="prop.item.disabled"
            v-model="prop.form.outboundObjectsName"
            placeholder="请选择出库对象名称"
        />
        <ChooseDriver
            style="display: inline-block"
            v-if="prop.form.outboundObjects==='司机'"
            :isRadio="true"
            placeholder="请选择出库对象名称"
            :disabled="prop.item.disabled"
            v-model="prop.form.outboundObjectsName"
            :fnRadioDisabled="
            (item) => {
              return item.state !== 2;
            }
          "
        />
      </section>
      <section slot="serviceProviderAddress" slot-scope="prop">
        <ChooseSite
            :isRadio="true"
            :isInput="true"
            v-model="prop.form.serviceProviderAddress"
            :otherSearchData="{isInventory:true}"
            :placeholder="'请输入/请选择服务站点'"
            @change="chooseSiteChange"
        />
      </section>
      <span slot="accessoryModelTip" class="warning" v-show="otherFormData.isaccessoryName &&otherFormData.isUnitPrice && otherFormData.operationType==='2'" style="margin-left: 20px">
        <i class="el-icon-warning error" />
        该配件未入库！
      </span>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getEnumList,
} from 'api';
import {getAccessoryModelList, getAccessoryNameList, getInventoryList} from 'api/service';
import {dealNumber, formatDateTimeSecond} from '@qx/utils';
import ChooseSite from 'components/choose/site';
import ChooseVehicle from 'components/choose/vehicle';
import ChooseDriver from 'components/choose/driver';
export default {
  components: {
    ChooseSite,
    ChooseVehicle,
    ChooseDriver,
  },
  data () {
    return {
      accessoryId: '',
      otherFormData: {
        isaccessoryName: false,
        isUnitPrice: false, // 判断入库单价是否有选择项
        operationType: '', // 出入库类型
      },
      addInventory: ['addUnitPrice', 'serviceProviderAddress', 'serviceProvider'], // 入库的表单
      reduceInventory: ['addInventoryUnitPrice', 'addInventoryUnitPrice', 'outboundObjects', 'reduceUnitPrice', 'remainingInventory', 'outboundObjectsName'], // 出库的表单

      baseForm: {
        operationTypeOptions: [], // 类型
        accessoryNameOptions: [], // 配件名称
        accessoryModelOptions: [], // 配件型号
        addInventoryUnitPriceOptions: [], // 入库单价
        form: [
          {
            label: '类型',
            value: 'operationType',
            placeholder: '请选择类型',
            type: 'select',
            onChange: this.operationTypeChange,
          },
          {
            label: '配件名称',
            value: 'accessoryName',
            type: 'select',
            filterable: true,
            placeholder: '请选择配件名称',
            onChange: async () => {
              this.$refs.baseForm.setVal('accessoryModel', '');
              this.$refs.baseForm.setVal('addInventoryUnitPrice', '');
              this.$refs.baseForm.setVal('remainingInventory', '');
              const accessoryName = this.baseForm.accessoryNameOptions.find((item) => item.value === this.$refs.baseForm.getVal('accessoryName'));
              const res = await getAccessoryModelList({
                accessoryName: accessoryName.label,
              });
              this.baseForm.accessoryModelOptions = res;
              this.otherFormData.isaccessoryName = true;
              this.otherFormData.isUnitPrice = false;

            },
          },
          {
            label: '配件型号',
            value: 'accessoryModel',
            type: 'select',
            filterable: true,
            placeholder: '请选择配件型号',
            onChange: async () => {
              this.$refs.baseForm.setVal('addInventoryUnitPrice', '');
              const accessoryName = this.baseForm.accessoryNameOptions.find((item) => item.value === this.$refs.baseForm.getVal('accessoryName'));
              const accessoryModel = this.baseForm.accessoryModelOptions.find((item) => item.value === this.$refs.baseForm.getVal('accessoryModel'));
              this.accessoryId = accessoryModel.value;
              const res = await getInventoryList({
                accessoryName: accessoryName.label,
                accessoryModel: accessoryModel.label,
              });
              if (res.length > 0) {
                this.otherFormData.isUnitPrice = false;
                this.baseForm.addInventoryUnitPriceOptions = res;
              } else {
                this.baseForm.addInventoryUnitPriceOptions = [];
                this.otherFormData.isUnitPrice = true;
              }

            },
          },
          {
            label: '入库单价',
            value: 'addInventoryUnitPrice',
            type: 'select',
            placeholder: '请选择入库单价',
            hide: true,
            onChange: async () => {
              const accessoryName = this.baseForm.accessoryNameOptions.find((item) => item.value === this.$refs.baseForm.getVal('accessoryName'));
              const accessoryModel = this.baseForm.accessoryModelOptions.find((item) => item.value === this.$refs.baseForm.getVal('accessoryModel'));
              const addInventoryUnitPrice = this.baseForm.addInventoryUnitPriceOptions.find((item) => item.value === this.$refs.baseForm.getVal('addInventoryUnitPrice'));
              const res = await getInventoryList({
                accessoryName: accessoryName.label,
                accessoryModel: accessoryModel.label,
                unitPrice: addInventoryUnitPrice.label * 100,
              });
              this.$refs.baseForm.setVal('remainingInventory', res[0].inventoryQuantity);
              this.$refs.baseForm.setVal('reduceUnitPrice', addInventoryUnitPrice.label);
            },
          },
          {
            label: '剩余库存量',
            value: 'remainingInventory',
            type: 'show',
            hide: true,
          },
          {
            label: '出库单价',
            value: 'reduceUnitPrice',
            type: 'input',
            placeholder: '请输入出库单价',
            onInput: (reduceUnitPrice) => {
              this.$refs.baseForm.setVal('reduceUnitPrice', dealNumber(reduceUnitPrice, false));
            },
            hide: true,
          },
          {
            label: '数量',
            value: 'inOutQuantity',
            type: 'inputNumber',
            placeholder: '',
            attr: {
              min: 1,
            },
            onKeyup: (inOutQuantity) => {
              this.$refs.baseForm.setVal('inOutQuantity', inOutQuantity.target.value.replace(/[^\d]/g, ''));
            },
          },
          {
            label: '单价',
            value: 'addUnitPrice',
            type: 'input',
            placeholder: '请输入配件单价',
            onInput: (addUnitPrice) => {
              this.$refs.baseForm.setVal('addUnitPrice', dealNumber(addUnitPrice, false));
            },
            hide: true,
          },
          {
            label: '出库对象',
            value: 'outboundObjects',
            slot: true,
            hide: true,
          },
          {
            label: '服务站点',
            value: 'serviceProviderAddress',
            default: {},
            slot: true,
            hide: true,
          },
          {
            label: '供应商',
            value: 'serviceProvider',
            type: 'input',
            placeholder: '请输入供应商',
            hide: true,
          },
          {
            label: '出库对象名称',
            value: 'outboundObjectsName',
            default: {},
            hide: true,
            slot: true,
          },
          {
            label: '出入库时间',
            value: 'outboundObjectsTime',
            type: 'date',
            placeholder: '请选择出入库时间',
            attr: {
              type: 'datetime',
              time: '00:00:00',
              format: 'yyyy-MM-dd HH:mm:ss',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
            },
          },
          {
            label: '备注',
            value: 'remarks',
            type: 'input',
            placeholder: '请输入备注信息',
          },
        ],
        rules: {
          operationType: [
            { required: true, message: '请选择类型', trigger: 'blur'},
          ],
          accessoryName: [
            { required: true, message: '请选择配件名称', trigger: ['blur', 'change']},
          ],
          accessoryModel: [
            { required: true, message: '请选择配件型号', trigger: ['blur', 'change']},
          ],
          addInventoryUnitPrice: [
            { required: true, message: '请选择入库单价', trigger: ['blur', 'change'] },
          ],
          inOutQuantity: [
            { required: true, message: '请输入数量', trigger: 'blur' },
          ],
          remainingInventory: [
            { required: true, message: '请选择入库单价', trigger: 'blur' },
          ],
          addUnitPrice: [
            { required: true, message: '请输入配件单价', trigger: 'blur' },
          ],
          reduceUnitPrice: [
            { required: true, message: '请输入出库单价', trigger: ['blur', 'change'] },
          ],
          unitPrice: [
            { required: true, message: '请输入配件单价', trigger: 'blur' },
          ],
          outboundObjects: [
            { required: true, message: '请选择出库对象', trigger: 'blur' },
          ],
          outboundObjectsName: [
            { required: true, message: '请选择出库对象名称', trigger: 'change' },
            {
              validator: (rule, value, callback) => this.checkObjEmpty(rule, value, callback, '请选择出库对象名称'),
              trigger: 'blur',
            },
          ],
          outboundObjectsTime: [
            { required: true, message: '请选择出入库时间', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getList () {
      const enumsList = await getEnumList({
        codeType: 'INVENTORY_OPER_TYPE',
      });
      this.baseForm.operationTypeOptions = enumsList[0];
      const accessoryName = await getAccessoryNameList({
        accessoryName: '',
      });
      this.baseForm.accessoryNameOptions = accessoryName;
    },
    operationTypeChange () {
      const type = this.$refs.baseForm.getVal('operationType');
      this.otherFormData.operationType = type;
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: type === '1',
        names: this.reduceInventory,
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: type === '2',
        names: this.addInventory,
      });


    },
    outboundObjectsInput (val) {
      if (val) {
        this.$refs.baseForm.setVal('outboundObjectsName', '');
      }
    },
    chooseSiteChange (selectedSiteInfo) {
      this.$refs.baseForm.setVal('serviceProvider', selectedSiteInfo.serviceName);
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (formData.operationType === '1') {
          formData.unitPrice = formData.addUnitPrice;
          formData.serviceProviderAddress = formData.serviceProviderAddress ? formData.serviceProviderAddress.productName : '';
        } else {
          if (formData.outboundObjectsName) {
            if (formData.outboundObjects === '车辆') {

              formData.outboundObjectsName = formData.outboundObjectsName.plateNumber;
            } else {
              formData.outboundObjectsName = formData.outboundObjectsName.linkman;
            }
          }
          formData.addInventoryUnitPrice = formData.addInventoryUnitPrice ? this.baseForm.addInventoryUnitPriceOptions.find((item) => item.value === formData.addInventoryUnitPrice).label : '';
          formData.unitPrice = formData.reduceUnitPrice;
        }
        formData.accessoryId = this.accessoryId;
      }
      console.log('eee', formData);
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return res;
    },
    async sub () {
      let formData = await this.handleSubData();
      if (formData.operationType === '1') {
        delete formData.outboundObjects;
        delete formData.outboundObjectsName;
        delete formData.addUnitPrice;
        delete formData.remainingInventory;
        delete formData.addInventoryUnitPrice;
        delete formData.reduceUnitPrice;
      } else if (formData.operationType === '2') {
        delete formData.serviceProviderAddress;
        delete formData.serviceProvider;
        delete formData.reduceUnitPrice;
      }
      console.log('formData', formData);
      return formData;
    },
    setBaseForm () {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
        names: [...this.addInventory, ...this.reduceInventory],
      });
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();
      if (!data.operationType) {
        this.setBaseForm();
      }
      if (!data.outboundObjectsTime) {
        data.outboundObjectsTime = formatDateTimeSecond(new Date());
      }
      if (!data.outboundObjects) {
        data.outboundObjects = '车辆';
      }
      if (!data.inOutQuantity) {
        data.inOutQuantity = 1;
      }
      data.serviceProviderAddress = data.serviceProviderAddress || {};
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
